<script>
  import Visible from '$lib/components/Visible.svelte';
  import { onMount } from 'svelte';

  export let introElements;

  let elementPositionsXL = {
    'big-year-2007': { top: 2.5, left: 260 },
    'text-2007': { top: 3.1, left: 425 },
    'big-year-2014': { top: 9.5, left: 670 },
    'text-2014': { top: 11.1, left: 820 },
    'text-2015': { top: 23.3, left: 855 },
    'text-2017': { top: 37.5, left: 460 },
  };

  let elementPositionsLG = {
    'big-year-2007': { top: 2.5, left: 115 },
    'text-2007': { top: 3.3, left: 280 },
    'big-year-2014': { top: 11.5, left: 490 },
    'text-2014': { top: 13, left: 630 },
    'text-2015': { top: 25.5, left: 670 },
    'text-2017': { top: 38.5, left: 450 },
  };

  let elementPositionsMD = {
    'big-year-2007': { top: 2.5, left: 60 },
    'text-2007': { top: 4.3, left: 220 },
    'big-year-2014': { top: 12.5, left: 370 },
    'text-2014': { top: 17.5, left: 420 },
    'text-2015': { top: 29, left: 10 },
    'text-2017': { top: 41.5, left: 10 },
  };

  let elementPositionsSM = {
    'big-year-2007': { top: 2.5, left: 60 },
    'text-2007': { top: 4.3, left: 180 },
    'big-year-2014': { top: 12.5, left: 370 },
    'text-2014': { top: 27.5, left: 33 },
    'text-2015': { top: 35.5, left: 33 },
    'text-2017': { top: 49, left: 33 },
  };

  let elementPositionsXS = {
    'text-2007': { top: 1.4, left: 130 },
    'text-2014': { top: 16.5, left: 2 },
    'text-2015': { top: 21, left: 2 },
    'text-2017': { top: 31.5, left: 2 },
  };

  let elementPositions = {};

  const updateElementPositions = () => {
    if (window.innerWidth <= 524) {
      elementPositions = { ...elementPositionsXS }; // Use XS values
    } else if (window.innerWidth <= 674) {
      elementPositions = { ...elementPositionsSM }; // Use SM values
    } else if (window.innerWidth <= 944) {
      elementPositions = { ...elementPositionsMD }; // Use MD values
    } else if (window.innerWidth <= 1214) {
      elementPositions = { ...elementPositionsLG }; // Use LG values
    } else {
      elementPositions = { ...elementPositionsXL }; // Use XL values
    }
  };

  onMount(() => {
    updateElementPositions(); // Initialize elementPositions based on screen size
    window.addEventListener('resize', updateElementPositions);

    return () => {
      window.removeEventListener('resize', updateElementPositions);
    };
  });
</script>

<div class="text-container">
  {#each introElements as element}
    {#if element.type === 'intro-text'}
      <div
        class={element.cls}
        id={element.Id}
        style="top: {elementPositions[element.Id]
          ?.top}%; left:{elementPositions[element.Id]?.left}px"
      >
        <Visible top="-50" let:visible>
          {#if visible}
            <div class:show-text={true}>
              <p>{@html element.text}</p>
            </div>
          {:else}
            <div class:hide-text={true}>
              <p>{@html element.text}</p>
            </div>
          {/if}
        </Visible>
      </div>
    {/if}
    {#if element.type === 'big-year'}
      <div
        class={element.cls}
        style="top: {elementPositions[element.Id]
          ?.top}%; left:{elementPositions[element.Id]?.left}px"
      >
        <Visible top="-50" let:visible>
          {#if visible}
            <div class:show-text={true}>
              <div class="top-line">{element.topLine}</div>
              <div class="bottom-line">{element.bottomLine}</div>
            </div>
          {:else}
            <div class:hide-text={true}>
              <div class="top-line">{element.topLine}</div>
              <div class="bottom-line">{element.bottomLine}</div>
            </div>
          {/if}
        </Visible>
      </div>
    {/if}
  {/each}
</div>

<style lang="scss">
  $desktopHeight: 2850px;

  .text-container {
    position: relative;
    width: 100%;
    height: $desktopHeight;
    font-family: 'LibreBodoni-Regular';
    .intro-text,
    .big-year {
      .show-text {
        animation: fadeIn 0.3s;
        opacity: 1;
      }
      .hide-text {
        animation: fadeOut 0.6s;
        opacity: 0.3;
      }
    }

    @keyframes fadeIn {
      0% {
        opacity: 0.3;
      }
      100% {
        opacity: 1;
      }
    }
    @keyframes fadeOut {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0.3;
      }
    }
  }

  .big-year,
  .intro-text {
    position: absolute;
  }

  div.big-year {
    color: var(--zinc-300);
    font-weight: 700;

    .top-line {
      font-size: 73px;
      margin: 0px;
      line-height: 0.9;
    }

    .bottom-line {
      font-size: 90px;
      margin: -0.6rem auto 0px 1.4rem;
      line-height: 0.9;
    }
  }

  div.intro-text {
    max-width: 300px;
    text-wrap: pretty;

    p {
      font-family: 'LibreBodoni-Regular';
      font-size: var(--theme-font-size-body);
      color: #000000;
    }
  }

  .lil-year {
    color: var(--zinc-300);
  }

  h1 {
    color: #000000;
    font-weight: 400;
  }

  #bigger,
  #bold,
  #er {
    text-transform: uppercase;
    font-size: calc(2 * var(--theme-font-size-6xl));
  }

  #bold {
    font-size: calc(3.3 * var(--theme-font-size-6xl));
  }

  #er {
    font-size: calc(2.5 * var(--theme-font-size-6xl));
  }

  #on-the-red-carpet {
    z-index: 1;
  }

  @media (max-width: 674px) {
    .big-year {
      display: none;
    }
  }

  @media (max-width: 524px) {
    .intro-text {
      font-size: var(--theme-font-size-sm);
      &#text-2014,
      &#text-2015 {
        max-width: 200px;
      }
    }
  }
</style>
